module.exports = __webpack_public_path__ + "static/img/company-2.ab528b28.png";